export enum EQuoteDeductionCategory {
  Discount = "Discount",
  Referral = "Referral",
  Promotion = "Promotion",
  Sale = "Sale",
  Grant = "Grant",
  CarbonCredit = "CarbonCredit"
}
